
import Search from "@/components/search/Search"
import LoginProfileButtons from "@/components/auth/LoginProfileButtons"

import { mapGetters } from "vuex"
import { mdiMenu } from "@mdi/js"

const DEFAULT_OFFSET = 280

export default {
    name: "Toolbar",
    components: { Search, LoginProfileButtons },
    props: {
        outside: {
            type: Boolean,
            default: true,
        },
        noSearch: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        scrollDistance: 0,
        scrolled: false,
        mdiMenu: mdiMenu,
    }),
    computed: {
        ...mapGetters("search", {
            isSearchActive: "active",
            searchLocation: "location",
            route: "route",
            channel: "channel",
            selectedCategory: "selectedCategory",
        }),
        ...mapGetters("meta", ["meta"]),
        metaProps() {
            return this.meta.toolbar ?? {}
        },
        scrollOffset() {
            return this.metaProps.scrollOffset || DEFAULT_OFFSET
        },
        hideSearch() {
            return (
                this.metaProps.hideSearch ||
                this.noSearch ||
                (this.scrolled && !this.metaProps.keepSearch)
            )
        },
        hideToolbar() {
            return this.metaProps.hideToolbar
        },
        absolute() {
            return !!this.metaProps.absolute
        },
        transparent() {
            return (
                !this.scrolled && !(this.metaProps.persistent || this.outside)
            )
        },
        backgroundStyle() {
            if (!this.transparent) {
                return "background: #fff !important"
            }
            return "background: #0000 !important"
        },
        title() {
            return this.metaProps.title
        },
        hideLogo() {
            return this.metaProps.hideLogo && this.$breakpoint.smAndDown
        },
        isSchool() {
            return this.$auth.user && this.$auth.user.school
        },
        isFlat() {
            return (
                this.transparent || (this.$route.path === "/" && !this.scrolled)
            )
        },
        showCompanyRoute() {
            return (
                !this.$auth.loggedIn &&
                (this.$breakpoint.lgAndUp ||
                    (this.$breakpoint.mdOnly && this.$route.path === "/")) &&
                !this.metaProps.hideLogin
            )
        },
        showLogin() {
            return this.$breakpoint.mdAndUp && !this.metaProps.hideLogin
        },
        showLogo() {
            return (
                (this.$breakpoint.lgAndUp && !this.hideLogo) ||
                this.$route.path === "/" ||
                this.metaProps.persistentLogo
            )
        },
        routeToForBusiness() {
            return this.metaProps.arbeitgeberRoute
        },
        landshutCustomNewTab() {
            // Remove when jobfair landshut starts
            if (this.$route.path === "/messe/berufsinfomesse-landshut") {
                return { target: "_blank" }
            }
            return {}
        },
    },
    mounted() {
        window && window.addEventListener("scroll", this.handleScroll)
    },
    destroyed() {
        window && window.removeEventListener("scroll", this.handleScroll)
    },
    methods: {
        handleScroll() {
            if (window) {
                if (window.scrollY < this.scrollOffset) {
                    if (this.scrolled === true) {
                        this.scrolled = false
                    }
                } else if (this.scrolled === false) {
                    this.scrolled = true
                }
            }
        },
    },
}
